import { MimshakData } from "../interfaces/DTO/mimshakData";
import { AdjustedProductType, InvestmentPathDetail, PolicyOrAccount, Product, ProductType } from "../interfaces/DTO/mislaka_xml_models";
export { setMultiplePathsInProduct, setPathCodeInProduct } from "../hooks/feeLab/useNewProductHandlers";
export type { PathFundSelection } from "../hooks/feeLab/useNewProductHandlers";


export class MimshakProductUtil {
  static hasInsuranceCoverages(product: Product): boolean {
    return (product.policies_or_accounts || []).some(
      (policy) => policy.insurence_coverages && policy.insurence_coverages.length > 0
    );
  }

  static countInsuranceCoverages(product: Product): number {
    return (product.policies_or_accounts || []).reduce((sum, policy) => {
        const coverages = policy.insurence_coverages || [];
        const count = coverages.filter(coverage =>
        coverage.coverage_details != null ||
        (Array.isArray(coverage.insurance_coverage) && coverage.insurance_coverage.length > 0) ||
        (Array.isArray(coverage.coverages) && coverage.coverages.length > 0) ||
        (Array.isArray(coverage.basic_insurance) && coverage.basic_insurance.length > 0)
        ).length;
        return sum + count;
    }, 0);
    }


  static hasInvestmentPaths(product: Product): boolean {
    return (product.policies_or_accounts || []).some(
      (policy) => policy.investment_paths && policy.investment_paths.length > 0
    );
  }

  static countInvestmentPaths(product: Product): number {
    return (product.policies_or_accounts || []).reduce(
      (sum, policy) => sum + (policy.investment_paths?.length || 0),
      0
    );
  }

  static hasLoans(product: Product): boolean {
    return (product.policies_or_accounts || []).some(
      (policy) => policy.loan_details && policy.loan_details.length > 0
    );
  }

  static countLoans(product: Product): number {
    return (product.policies_or_accounts || []).reduce(
      (sum, policy) => sum + (policy.loan_details?.length || 0),
      0
    );
  }

  static hasDebts(product: Product): boolean {
    return (product.policies_or_accounts || []).some(
      (policy) => policy.debt_details && policy.debt_details.length > 0
    );
  }

  static countDebts(product: Product): number {
    return (product.policies_or_accounts || []).reduce(
      (sum, policy) => sum + (policy.debt_details?.length || 0),
      0
    );
  }

  static hasPensionCoverages(product: Product): boolean {
    return (product.policies_or_accounts || []).some(
      (policy) =>
        policy.insurence_coverages &&
        policy.insurence_coverages.some(
          (coverage) => coverage.coverages && coverage.coverages.length > 0
        )
    );
  }

  static countPensionCoverages(product: Product): number {
    return (product.policies_or_accounts || []).reduce(
      (total, policy) =>
        total +
        (policy.insurence_coverages?.reduce(
          (sum, coverage) => sum + (coverage.coverages?.length || 0),
          0
        ) || 0),
      0
    );
  }

  static hasBasicInsurance(product: Product): boolean {
    return (product.policies_or_accounts || []).some(
      (policy) =>
        policy.insurence_coverages &&
        policy.insurence_coverages.some(
          (coverage) => coverage.basic_insurance && coverage.basic_insurance.length > 0
        )
    );
  }

  static countBasicInsurance(product: Product): number {
    return (product.policies_or_accounts || []).reduce(
      (acc, policy) =>
        acc +
        (policy.insurence_coverages?.reduce(
          (sum, coverage) => sum + (coverage.basic_insurance?.length || 0),
          0
        ) || 0),
      0
    );
  }

  static hasPremiumPeriods(product: Product): boolean {
    return (product.policies_or_accounts || []).some(
      (policy) =>
        policy.insurence_coverages &&
        policy.insurence_coverages.some(
          (coverage) => coverage.premium_period && coverage.premium_period.length > 0
        )
    );
  }

  static countPremiumPeriods(product: Product): number {
    return (product.policies_or_accounts || []).reduce(
      (total, policy) =>
        total +
        (policy.insurence_coverages?.filter(
          (coverage) => coverage.premium_period && coverage.premium_period.length > 0
        ).length || 0),
      0
    );
  }
  static hasPathCode(product: Product): boolean {
    if (product.details.product_type === ProductType.PURE_RISK_POLICY
      ||   product.details.product_type === ProductType.COLLECTIVE_RISK_POLICY
      ||   product.details.product_type === ProductType.MORTGAGE_LIFE_INSURANCE
      
    ) return false; 
    else return true;
  }
static hasPensionData(product: Product): boolean {
    if (product.details.product_type === ProductType.CHILD_SAVINGS
      ||   product.details.product_type === ProductType.PURE_RISK_POLICY
      ||   product.details.product_type === ProductType.COLLECTIVE_RISK_POLICY
      ||   product.details.product_type === ProductType.MORTGAGE_LIFE_INSURANCE
      ||  product.details.product_type === ProductType.INVESTMENT_PROVIDENT_FUND
      ||  product.details.product_type === ProductType.EDUCATION_FUND
      ||  product.details.adjusted_product_type === AdjustedProductType.PURE_SAVINGS_POLICY
    ) return false; // 
    return (product.policies_or_accounts || []).some(
      (policy) => !!policy.pension_data || !!policy.retirement_savings_by_age
    );
  }
  static hasPensionDetails(product: Product): boolean {
    if (product.details.product_type === ProductType.CHILD_SAVINGS
      ||   product.details.product_type === ProductType.PURE_RISK_POLICY
      ||   product.details.product_type === ProductType.COLLECTIVE_RISK_POLICY
      ||   product.details.product_type === ProductType.MORTGAGE_LIFE_INSURANCE
      ||  product.details.product_type === ProductType.INVESTMENT_PROVIDENT_FUND
      ||  product.details.product_type === ProductType.EDUCATION_FUND
       ||  product.details.adjusted_product_type === AdjustedProductType.PURE_SAVINGS_POLICY
    ) return false; // רק עבור מוצרי פנסיה
    return (product.policies_or_accounts || []).some(
      (policy) => !!policy.pension_fund_details || !!policy.pension_data
    );
  }

  static countPensionData(product: Product): number {
    return (product.policies_or_accounts || []).filter(
      (policy) => !!policy.pension_data
    ).length;
  }
static isPathCodeInProduct = (
  product: Product,
  policyNumber: string,
  fundId: number
): boolean => {
  if (!product.policies_or_accounts) return false;

  for (const policy of product.policies_or_accounts) {
    if (policy.policy_number === policyNumber && policy.investment_paths) {
      for (const path of policy.investment_paths) {
        if (path.path_code === fundId) {
          return true;
        }
      }
    }
  }

  return false;
};
static getPathCodesFromProduct = (product: Product): number[] => {
  const pathCodes: number[] = [];

  if (!product.policies_or_accounts) return pathCodes;

  for (const policy of product.policies_or_accounts) {
    if (policy.investment_paths) {
      for (const path of policy.investment_paths) {
        if (typeof path.path_code === "number") {
          pathCodes.push(path.path_code);
        }
      }
    }
  }

  return pathCodes;
};

static getMergedPathsFromProduct = (product: Product): InvestmentPathDetail[] => {
  if (!product?.policies_or_accounts) return [];

  const allPaths: InvestmentPathDetail[] = [];

  for (const policy of product.policies_or_accounts) {
    if (policy.investment_paths) {
      allPaths.push(...policy.investment_paths);
    }
  }

  // מיזוג מסלולים כפולים לפי path_code
  const grouped = allPaths.reduce<Record<number, InvestmentPathDetail>>((acc, path) => {
    const code = path.path_code;
    if (!acc[code]) {
      acc[code] = { ...path };
    } else {
      acc[code].accumulated_amount = (acc[code].accumulated_amount ?? 0) + (path.accumulated_amount ?? 0);
      const sumPercentage = (acc[code].deposit_percentage ?? 0) + (path.deposit_percentage ?? 0);
      acc[code].deposit_percentage = Math.round(sumPercentage * 100) / 100;
    }
    return acc;
  }, {});

  return Object.values(grouped);
};
  /**
   * Earliest product_join_date across policies, as a YYYYMM number, or null if none exist.
   */
  static getMinJoinDateKey(policies: PolicyOrAccount[]): number | null {
    return policies.reduce<number | null>((min, p) => {
      if (!p.product_join_date) return min;
      const d = new Date(p.product_join_date);
      const key = d.getFullYear() * 100 + (d.getMonth() + 1);
      return min === null ? key : Math.min(min, key);
    }, null);
  }

  static getFutureTemporaryRiskEndDates(mimshakData: MimshakData): string[] {
    const today = new Date();
    const dates: string[] = [];
    for (const product of mimshakData.data?.products ?? []) {
      for (const policy of product.policies_or_accounts ?? []) {
        const d = policy.pension_data?.end_date_temporary_risk;
        if (d && new Date(d) > today) dates.push(d);
      }
    }
    return [...new Set(dates)];
  }

}
